import React from 'react';

/**
 * Floating AI status bubble — bottom-right, dotted-pulse "thinking" dots.
 * Click is a no-op for now; future phase will expand it into a chat surface.
 */
export function AIBubble({ label = 'AutoMind AI', detail = 'idle', onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="ai-bubble focus-2050 text-ink-700 dark:text-ink-100"
      aria-label="Open AutoMind assistant"
    >
      <span className="ai-dots" aria-hidden="true">
        <span /><span /><span />
      </span>
      <span className="text-xs">
        {label} <span className="text-ink-500">·</span> <span className="nums">{detail}</span>
      </span>
    </button>
  );
}
export default AIBubble;
